import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { useSEO } from '../../utils/seo';

const Home: React.FC = () => {
  useSEO({
    title: '村屋僭建物申報 TCP T1 T3 BD T1 T3 BD T1 T3 RSE T3 國內T1 適任技術人員註冊',
    description: '焯峯工程提供專業村屋僭建物申報服務，包括TCP T1、TCP T3、BD T1、BD T3、RSE T3及國內T1適任技術人員註冊。專業團隊處理新界村屋僭建物申報及安全檢驗，確保符合屋宇署監督制度。立即聯絡獲取村屋僭建物申報免費諮詢。',
    keywords: '村屋僭建物申報,TCP T1,TCP T3,BD T1,BD T3,RSE T3,國內T1,適任技術人員,焯峯工程,屋宇署,新界村屋,僭建物申報,工程監督,玻璃熱浸',
    canonical: '/',
    schema: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "焯峯工程有限公司",
      "description": "專業香港工程服務公司，提供村屋僭建物申報、TCP T1、TCP T3、BD T1、BD T3、RSE T3及國內T1適任技術人員註冊服務",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "HK",
        "addressRegion": "香港"
      },
      "serviceArea": {
        "@type": "Place",
        "name": "香港"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+852-9189-8819",
        "contactType": "customer service",
        "availableLanguage": ["zh-HK", "zh-CN"]
      },
      "sameAs": [
        "https://wa.me/85291898819"
      ]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
